export default __webpack_public_path__ + "static/Inter-afdb8a07907da21452bf47ade5d4b5a1.ttf";